var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15697 16.8L4 20",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4168 13.5571L19.4686 8.97046C19.679 8.54379 19.5738 8.01046 19.2581 7.58379L19.8895 6.62379C20.1 6.41045 19.9947 5.98379 19.679 5.66379L18.311 4.27713C17.9953 3.95713 17.6796 3.95713 17.3639 4.0638L16.4168 4.70379C15.8907 4.27713 15.3645 4.17046 14.9436 4.49046L10.4186 7.58379C8.73486 7.47712 6.94591 8.11713 5.68312 9.39713L5.47266 9.61046L14.207 18.4638L14.4174 18.2504C15.8907 17.1838 16.5221 15.3705 16.4168 13.5571Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatPin);
export default __webpack_public_path__ + "static/media/chat_pin.d8a103e521afb09b2696ee00a3ee5fd8.svg";
export { ForwardRef as ReactComponent };